export const tooltipCardContentStyles = {
  display: "flex",
  alignContent: "center",
  flexDirection: "column",
  justifyContent: "space-around",
  padding: "2vh",
  height: "10vh",
};
